module.exports = __webpack_public_path__ + "img/柔性生产ico.3679b442.png";